// extracted by mini-css-extract-plugin
export default {"titleText":"TitleButton_titleText__OJdFL","linkStyle":"TitleButton_linkStyle__oSNUV"};